import { useEffect, useState } from "react";

type GPCStatus = "enabled" | "disabled" | "unsupported";

// Detects whether the browser exposes the Global Privacy Control (GPC) signal
// and whether it is currently enabled.
export const useGlobalPrivacyControl = () => {
  const [status, setStatus] = useState<GPCStatus>(() => {
    if (typeof navigator === "undefined") return "unsupported";
    const gpcValue = (navigator as any).globalPrivacyControl;
    if (typeof gpcValue === "boolean") {
      return gpcValue ? "enabled" : "disabled";
    }
    return "unsupported";
  });

  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const gpcValue = (navigator as any).globalPrivacyControl;
    if (typeof gpcValue === "boolean") {
      setStatus(gpcValue ? "enabled" : "disabled");
    } else {
      setStatus("unsupported");
    }
  }, []);

  return {
    status,
    supported: status !== "unsupported",
    enabled: status === "enabled",
  };
};

